import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Message, Button, Table, InfoText } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { session } from './formatSession';
import Styles from './confirmModal.module.css';

function ItemLine({ label, children }) {
    return (
        <div className={Styles['item-line']}>
            <div className={Styles['item-line-label']}>{label}</div>
            <div className={Styles['item-line-children']}>{children}</div>
        </div>
    );
}
ItemLine.propTypes = {
    label: PropTypes.string
};

function HeaderRow() {
    const { t } = useTranslation();

    return (
        <Table.Tr isHeader>
            <th>{t('ticket.webservice.ticket-list.header.barcode')}</th>
            <th>{t('ticket.webservice.ticket-list.header.event')}</th>
            <th>{t('ticket.webservice.ticket-list.header.rate')}</th>
        </Table.Tr>
    );
}

function TableRow({ subscription }) {
    return (
        <Table.Tr>
            <Table.Td>
                <InfoText subtitle={subscription.barcode}>{subscription.ticket_identifier}</InfoText>
            </Table.Td>
            <Table.Td>{subscription.event}</Table.Td>
            <Table.Td>{subscription.rate}</Table.Td>
        </Table.Tr>
    );
}
TableRow.propTypes = {
    subscription: PropTypes.object
};

function AttendeesList({ subscriptionTickets }) {
    return (
        <Table useNew className={Styles['attendees_table']}>
            <Table.THead>
                <HeaderRow />
            </Table.THead>
            <Table.TBody>
                {subscriptionTickets
                    .filter((_, index) => index < 5)
                    .map((subscription, i) => (
                        <TableRow key={i} subscription={subscription} />
                    ))}
            </Table.TBody>
        </Table>
    );
}
AttendeesList.propTypes = {
    subscriptionTickets: PropTypes.array
};

export default function ConfirmModal({ show, form, onSubmit, onClose, isSubmitting }) {
    const { t } = useTranslation();
    const [showAttendees, setShowAttendees] = React.useState(false);

    // TODO ADRIEN : Remove these raw data and make a filter on tickets on wendy
    const subscriptionTickets = [
        {
            ticket_identifier: 123355,
            barcode: 'BC2436756453',
            event: 'Event1',
            rate: 'Regular'
        },
        {
            ticket_identifier: 123355,
            barcode: 'BC2436756453',
            event: 'Event2',
            rate: 'Gratuit'
        },
        {
            ticket_identifier: 123355,
            barcode: 'BC2436756453',
            event: 'Event3',
            rate: 'Tarif'
        },
        {
            ticket_identifier: 123355,
            barcode: 'BC2436756453',
            event: 'Event1',
            rate: 'Regular'
        },
        {
            ticket_identifier: 123355,
            barcode: 'BC2436756453',
            event: 'Event2',
            rate: 'Gratuit'
        },
        {
            ticket_identifier: 123355,
            barcode: 'BC2436756453',
            event: 'Event3',
            rate: 'Tarif'
        }
    ];

    const onCloseModal = React.useCallback(() => {
        onClose();
        setShowAttendees(false);
    }, [onClose]);

    return (
        <>
            {
                <Modal
                    size="large"
                    open={show}
                    onClose={onCloseModal}
                    title={!showAttendees ? t('ticket.webservice.mapping.confirm-modal.subtitle') : t('ticket.webservice.subscription-link.confirm-modal.attendees-title')}
                    submitButton={
                        <>
                            {/* TODO: V2 */}
                            {/* {form.rules.length > 0 &&
                                (!showAttendees ? (
                                    <Button primary inverted onClick={() => setShowAttendees(true)} disabled={isSubmitting}>
                                        {t('ticket.webservice.subscription-link.confirm-modal.cta')}
                                    </Button>
                                ) : 
                                    <Button primary inverted onClick={() => setShowAttendees(false)} disabled={isSubmitting}>
                                        {t('ticket.common.cta.back')}
                                    </Button>
                                )} */}
                            <Button primary onClick={onSubmit} disabled={isSubmitting}>
                                {t('ticket.common.cta.save')}
                            </Button>
                        </>
                    }
                    cancelButton={<Button onClick={onCloseModal}>{t('ticket.common.cta.cancel')}</Button>}
                >
                    {!showAttendees ? (
                        <div>
                            <Message type="warning" title={t('ticket.webservice.subscription-link.confirm-modal.message.title')}>
                                {t('ticket.webservice.subscription-link.confirm-modal.message.info')}
                            </Message>
                            <div>
                                <ItemLine label={t('ticket.webservice.subscription-link.confirm-modal.conditions')}>
                                    {form.rules.length > 0
                                        ? form.rules.map((rule, i) => {
                                              return (
                                                  <div key={i} className={Styles['form-rule']}>
                                                      {rule.type}{' '}
                                                      <span className={Styles['highlighted']}>
                                                          {t(`ticket.webservice.subscription-link.confirm-modal.operator.${rule.operator}`)}
                                                      </span>{' '}
                                                      {rule.value}
                                                  </div>
                                              );
                                          })
                                        : '-'}
                                </ItemLine>
                                <ItemLine label={t('ticket.webservice.subscription-link.confirm-modal.event')}>{form.event?.name}</ItemLine>
                                <ItemLine label={t('ticket.webservice.subscription-link.confirm-modal.session')}>
                                    {form.session ? session(form.session.start_date, form.event) : '-'}
                                </ItemLine>
                                <ItemLine label={t('ticket.webservice.subscription-link.confirm-modal.rate')}>{form.rate_group?.name || '-'}</ItemLine>
                                {/* TODO: V2 */}
                                {/* <ItemLine label={t('ticket.webservice.subscription-link.confirm-modal.attendees')}>
                                    <span className={Styles['highlighted']}>{form.attendees || 0}</span>
                                </ItemLine> */}
                            </div>
                        </div>
                    ) : (
                        <div>
                            <AttendeesList subscriptionTickets={subscriptionTickets} />
                        </div>
                    )}
                </Modal>
            }
        </>
    );
}

ConfirmModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    isSubmitting: PropTypes.func.isRequired,
    form: PropTypes.object
};
